import { render } from "./statisticComponent.vue?vue&type=template&id=f7b55234"
import script from "./statisticComponent.vue?vue&type=script&lang=js"
export * from "./statisticComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/lexmodo/projects/wishlist_remote/wishlist_admin/wishlist-frontend-to-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__